import { createSelector } from 'reselect';

const tripCriteriaSelector = ({ tripCriteria }) => tripCriteria || {};

const mainContactSelector = createSelector(
  tripCriteriaSelector,
  ({ mainContact }) => mainContact || {},
);
const getDepartureCity = createSelector(
  tripCriteriaSelector,
  ({ departureCity }) => departureCity,
) as unknown as (state: ReduxState) => string | null | undefined;
const getDepartureDate = createSelector(
  tripCriteriaSelector,
  ({ departureDate }) => departureDate,
) as unknown as (state: ReduxState) => number | null | undefined;
const getArrivalDate = createSelector(
  tripCriteriaSelector,
  ({ arrivalDate }) => arrivalDate,
) as unknown as (state: ReduxState) => number | null | undefined;
const getMainContactOptinEmail = createSelector(
  mainContactSelector,
  ({ optinEmail }) => optinEmail,
);
const getMainContactOptinSms = createSelector(mainContactSelector, ({ optinSms }) => optinSms);
const getMainContactOptinMail = createSelector(mainContactSelector, ({ optinMail }) => optinMail);
const getMainContactOptinPhone = createSelector(
  mainContactSelector,
  ({ optinPhone }) => optinPhone,
);
const getMainContactOptinFosun = createSelector(
  mainContactSelector,
  ({ optinFosun }) => optinFosun,
);
const getTripDuration = createSelector(
  tripCriteriaSelector,
  ({ duration }) => duration,
) as unknown as (state: ReduxState) => number | null | undefined;
const getTripFlexibility = createSelector(
  tripCriteriaSelector,
  ({ flexibility }) => flexibility,
) as unknown as (state: ReduxState) => number | null | undefined;
export {
  getArrivalDate,
  getDepartureCity,
  getDepartureDate,
  getMainContactOptinEmail,
  getMainContactOptinSms,
  getMainContactOptinFosun,
  getMainContactOptinMail,
  getMainContactOptinPhone,
  getTripDuration,
  getTripFlexibility,
};
